import React, { useState, useEffect } from 'react';
import Modal from '../../../ui/Modal';

const KZT = new Intl.NumberFormat('ru-KZ', { maximumFractionDigits: 2 });

const fmtDate = (s) => {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleDateString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    timeZone: 'Europe/Moscow',
  });
};

function StatusBadge({ name }) {
  const n = String(name || '').toLowerCase();
  let tone = 'neutral';
  if (/ожидает|новая/.test(n))           tone = 'warning';
  else if (/подтверждена|готов|оплачен|доставлен|закрыт|завершен/.test(n)) tone = 'success';
  else if (/отмен|возврат|отклон/.test(n))     tone = 'danger';
  else if (/в пути|производ|собира/.test(n))   tone = 'info';
  return <span className={`crmpage__status crmpage__status--${tone}`}>{name || '—'}</span>;
}

const WeeklyOrderModal = ({ order, onClose }) => {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrderItems = async () => {
      if (!order?.id) return;
      setIsLoading(true);
      setError(null);
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}v1/order_orderitems/${order.id}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        setItems(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error(err);
        setError('Не удалось загрузить состав заказа');
      } finally {
        setIsLoading(false);
      }
    };
    fetchOrderItems();
  }, [order?.id]);

  if (!order) return null;

  const filteredItems = items.filter(it => Number(it['Количество']) > 0);
  const total = filteredItems.reduce(
    (sum, it) => sum + Number(it['Цена'] || 0) * Number(it['Количество'] || 0), 0
  );

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title={`Заявка №${order.order_number}`}
      subtitle={order.client_name}
      size="lg"
    >
      <div className="uimodal-field">
        <span className="uimodal-field__label">Договор</span>
        <span className="uimodal-field__value">{order.contract_number || '—'}</span>
      </div>
      <div className="uimodal-field">
        <span className="uimodal-field__label">Адрес доставки</span>
        <span className="uimodal-field__value">{order.delivery_address || '—'}</span>
      </div>

      <div className="uimodal-grid-2">
        <div>
          <span className="uimodal-field__label">Дата заказа</span>
          <span className="uimodal-field__value">{fmtDate(order.order_date)}</span>
        </div>
        <div>
          <span className="uimodal-field__label">Дата доставки</span>
          <span className="uimodal-field__value">{fmtDate(order.delivery_date)}</span>
        </div>
      </div>

      <div className="uimodal-grid-2">
        <div>
          <span className="uimodal-field__label">Статус заявки</span>
          <span className="uimodal-field__value"><StatusBadge name={order.status_name} /></span>
        </div>
        <div>
          <span className="uimodal-field__label">Статус оплаты</span>
          <span className="uimodal-field__value"><StatusBadge name={order.payment_status} /></span>
        </div>
      </div>

      <table className="uimodal-table">
        <thead>
          <tr>
            <th>Товар</th>
            <th className="num">Кол-во</th>
            <th>Ед.</th>
            <th className="num">Цена</th>
            <th className="num">Сумма</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr><td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#8C8077' }}>Загрузка…</td></tr>
          ) : error ? (
            <tr><td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#B73C36' }}>{error}</td></tr>
          ) : filteredItems.length > 0 ? filteredItems.map((it, idx) => {
            const qty = Number(it['Количество'] || 0);
            const price = Number(it['Цена'] || 0);
            return (
              <tr key={idx}>
                <td>{it['Товар']}</td>
                <td className="num">{qty}</td>
                <td>шт.</td>
                <td className="num">{KZT.format(price)} ₸</td>
                <td className="num">{KZT.format(qty * price)} ₸</td>
              </tr>
            );
          }) : (
            <tr><td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#8C8077' }}>Позиций нет</td></tr>
          )}
        </tbody>
      </table>

      <div className="uimodal-total">
        <span className="uimodal-total__label">Общая сумма</span>
        <span className="uimodal-total__value">{KZT.format(total)} ₸</span>
      </div>
    </Modal>
  );
};

export default WeeklyOrderModal;
